import PropTypes from 'prop-types';
import React from 'react';
import { generateSequence } from '~/modules/resourcing/common/util';
import { ResourceRequestStatus } from '~/types';
import { useResourceRequestToolbarContext } from '~/modules/projects/resourcing-plan/hooks';
import { useMeContext } from '~/modules/me';
import ResourceAllocationUsers from '../../../ResourceAllocationUsers';

import ResourceRequestBlockGroupBlock from '../ResourceRequestBlockGroupBlock/ResourceRequestBlockGroupBlock';
import ResourceRequestDrafts from './ResourceRequestDrafts';

export const ResourceRequestBlockGroup = ({
  resourceRequest,
  scale,
  chartDates,
  resourceAllocations,
  isResourceRequestReadOnly,
  isEditSwitchEnabled,
  showUserAssignmentColumn,
  chartDisplayDateRange,
  canViewCostData,
  displayUnit,
  dynamicContainerHeight
}) => {
  const [{ start: chartStartDate }] = chartDates;

  const {
    featureFlags: { isPSAActualCornerCasesEnabled, isPSARMP2023Q3BugsEnabled },
    permissionsMap
  } = useMeContext();

  const { isResourceActualModeEnabled } = useResourceRequestToolbarContext();

  const isResourceAssignmentEnabled = Boolean(
    permissionsMap[
      'urn:replicon:resource-assignment-action:edit-resource-assignments'
    ]
  );

  const isCompleteResourceAllocationPermissionEnabled = Boolean(
    permissionsMap['urn:replicon-webui:completed-resource-allocation:edit']
  );

  const isAllocationEditable =
    isEditSwitchEnabled &&
    isCompleteResourceAllocationPermissionEnabled &&
    isResourceAssignmentEnabled;

  const pendingAllocations =
    resourceRequest.requestStatus === ResourceRequestStatus.Submitted &&
    resourceAllocations.length > 0;

  const allAllocations =
    resourceRequest.requestStatus !== ResourceRequestStatus.Draft &&
    resourceAllocations.length > 0;

  return (
    <>
      {showUserAssignmentColumn && (
        <ResourceAllocationUsers
          resourceAllocations={resourceAllocations}
          scale={scale}
          chartDisplayDateRange={chartDisplayDateRange}
          resourceRequest={resourceRequest}
          chartDates={chartDates}
          isEditable={isAllocationEditable}
          dynamicContainerHeight={dynamicContainerHeight}
        />
      )}

      {!pendingAllocations &&
        (resourceRequest.requestStatus === ResourceRequestStatus.Draft ||
          resourceRequest.requestStatus === ResourceRequestStatus.Submitted ||
          resourceRequest.requestStatus === ResourceRequestStatus.Tobehired ||
          resourceRequest.requestStatus === ResourceRequestStatus.Rejected) && (
          <ResourceRequestDrafts
            resourceRequest={resourceRequest}
            isPSAActualCornerCasesEnabled={isPSAActualCornerCasesEnabled}
            isPSARMP2023Q3BugsEnabled={isPSARMP2023Q3BugsEnabled}
            scale={scale}
            isEditable={isEditSwitchEnabled}
            chartDates={chartDates}
            chartDisplayDateRange={chartDisplayDateRange}
            isResourceActualModeEnabled={isResourceActualModeEnabled}
          />
        )}
      {(pendingAllocations || allAllocations) &&
        generateSequence(resourceRequest.quantity).map((rowItem, rowIndex) => (
          <ResourceRequestBlockGroupBlock
            isResourceRequestReadOnly={isResourceRequestReadOnly}
            key={rowItem}
            rowIndex={rowIndex}
            resourceRequest={resourceRequest}
            chartStartDate={chartStartDate}
            isEditSwitchEnabled={isEditSwitchEnabled}
            scale={scale}
            canViewCostData={canViewCostData}
            chartDisplayDateRange={chartDisplayDateRange}
            displayUnit={displayUnit}
            isAllocationBlockPresent={Boolean(
              showUserAssignmentColumn &&
                isResourceRequestReadOnly &&
                resourceAllocations &&
                rowIndex < resourceAllocations.length
            )}
            isPSAActualCornerCasesEnabled={isPSAActualCornerCasesEnabled}
            isResourceActualModeEnabled={isResourceActualModeEnabled}
          />
        ))}
    </>
  );
};

ResourceRequestBlockGroup.propTypes = {
  scale: PropTypes.string.isRequired,
  resourceAllocations: PropTypes.array,
  resourceRequest: PropTypes.object.isRequired,
  canViewCostData: PropTypes.bool,
  isResourceRequestReadOnly: PropTypes.bool,
  chartDisplayDateRange: PropTypes.object.isRequired,
  displayUnit: PropTypes.string,
  showUserAssignmentColumn: PropTypes.bool,
  chartDates: PropTypes.array,
  isEditSwitchEnabled: PropTypes.bool,
  dynamicContainerHeight: PropTypes.number
};

export default ResourceRequestBlockGroup;
